export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6775.877d9830.jpg";